(function () {
	window.js = window.js || {};
	js.share = (function () {
		function initialize(domElm) {
			var oParent = document.getElementsByClassName('article__content');
			var oElm = document.getElementById('sticky--share');
			var nLastPos = scrollPosition();
			var nScrollPos = scrollPosition();

            var oHeader = document.getElementById('header'),
                oHeaderHeight = parseFloat(window.getComputedStyle(oHeader, null).getPropertyValue('height'));

            window.addEventListener("scroll", throttle(function () {
                var bScrollDir = nScrollPos > nLastPos,
                    oClientRect = oParent[0].getBoundingClientRect(),
                    oTop = oClientRect.top,
                    oBottom = oClientRect.bottom;
				
				if (oTop < 10) {
                    oElm.classList.add('sticky');
				}
                
                if ((oBottom < 400 && !bScrollDir) || oTop > oHeaderHeight) {
                	oElm.classList.remove('sticky', 'sticky--out'); 
				}
			   nLastPos = nScrollPos;
			}, 150));
			
			// Function also used in header.js
			function scrollPosition() {
				return (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
			}

			function throttle(fn, threshhold, scope) {
				threshhold = typeof threshhold !== "undefined" ? threshhold : 250;
				var
					last,
					deferTimer;
				return function () {
					var
						context = scope || this,
						now = +new Date(),
						args = arguments;
					if (last && now < last + threshhold) {
						clearTimeout(deferTimer);
						deferTimer = setTimeout(function () {
							last = now;
							fn.apply(context, args);
						}, threshhold);
					} else {
						last = now;
						fn.apply(context, args);
					}
				};
			}

		}
		return {
			initialize: initialize
		};

	})();
})();